import styled from 'styled-components';

export const S = {
  Container: styled.section``,

  ValueSpan: styled.span`
    font-weight: bold;
  `,
};
